export interface CityData {
  name: string;
  lat: number;
  lng: number;
}

export interface LocationData {
  slug: string;
  name: string;
  state: string;
  region: string;
  description: string;
  highlights: string[];
  content: string[];
  isPrimary: boolean;
  lat: number;
  lng: number;
  cities: CityData[];
}

export const locations: LocationData[] = [
  {
    slug: "phoenix",
    name: "Phoenix",
    state: "AZ",
    region: "Maricopa County",
    isPrimary: true,
    lat: 33.4484,
    lng: -112.074,
    description:
      "4 Seasons Painting is based on West Roosevelt Street in Phoenix. We paint homes and businesses across the entire Valley — interior, exterior, power washing, sun screens, gutters, and pergolas — and we answer the phone 24/7.",
    highlights: [
      "Headquartered in Phoenix, AZ 85043",
      "Interior & exterior painting citywide",
      "Available 24 hours a day, 7 days a week",
      "Licensed, insured & family-operated",
    ],
    content: [
      "Phoenix is home. Our shop sits on West Roosevelt Street and our crews run from Laveen and Maryvale to Arcadia, Ahwatukee, and North Phoenix every week. We know what the summer sun does to a west-facing stucco wall, and we spec coatings that actually survive it.",
      "Homeowners call us for full interior repaints, kitchen cabinet refinishing, and exterior color changes that need HOA approval. Businesses call us for storefronts, offices, apartment complexes, and rental turnovers that have to be done fast and done right.",
      "Call (480) 758-9380 for a free, no-pressure estimate anywhere in Phoenix.",
    ],
    cities: [
      { name: "Ahwatukee", lat: 33.3106, lng: -111.9847 },
      { name: "Arcadia", lat: 33.5, lng: -111.975 },
      { name: "Laveen", lat: 33.3628, lng: -112.1693 },
      { name: "Maryvale", lat: 33.4906, lng: -112.1738 },
    ],
  },
  {
    slug: "scottsdale",
    name: "Scottsdale",
    state: "AZ",
    region: "Maricopa County",
    isPrimary: false,
    lat: 33.4942,
    lng: -111.9261,
    description:
      "Scottsdale painting contractor for luxury interiors, exterior repaints, and custom pergolas. Detail-focused work with HOA color approval handled for you.",
    highlights: [
      "High-end interior & cabinet finishes",
      "Exterior repaints with HOA approval help",
      "Custom pergolas & patio covers",
      "Free written estimates",
    ],
    content: [
      "Scottsdale homes set a high bar and our finish work meets it. We handle designer color schemes, smooth-wall interiors, cabinet refinishing, and exterior repaints from Old Town to DC Ranch and Grayhawk.",
      "Most Scottsdale communities require HOA color approval before an exterior repaint. We prepare the samples and paperwork so your project doesn't stall waiting on a committee.",
      "Call (480) 758-9380 to book a free Scottsdale estimate.",
    ],
    cities: [
      { name: "Old Town", lat: 33.4919, lng: -111.9261 },
      { name: "North Scottsdale", lat: 33.65, lng: -111.9 },
      { name: "McCormick Ranch", lat: 33.5453, lng: -111.9 },
      { name: "Grayhawk", lat: 33.665, lng: -111.925 },
    ],
  },
  {
    slug: "gilbert",
    name: "Gilbert",
    state: "AZ",
    region: "Maricopa County",
    isPrimary: false,
    lat: 33.3528,
    lng: -111.789,
    description:
      "Gilbert, AZ house painters. Interior repaints, exterior stucco painting, sun screens, and seamless rain gutters for East Valley homes.",
    highlights: [
      "Whole-home interior repaints",
      "Exterior stucco & trim painting",
      "Sun screens that cut cooling bills",
      "Seamless rain gutter installation",
    ],
    content: [
      "Gilbert's newer subdivisions hit the age where builder-grade paint starts fading and cracking, and that's exactly when we get the call. We repaint exteriors with desert-rated coatings and refresh interiors room by room or all at once.",
      "Sun screens are especially popular here — west and south-facing windows in Gilbert take a beating, and custom screens knock a real dent in summer cooling costs.",
      "Get your free Gilbert estimate at (480) 758-9380.",
    ],
    cities: [
      { name: "Val Vista Lakes", lat: 33.36, lng: -111.75 },
      { name: "Agritopia", lat: 33.3097, lng: -111.7364 },
      { name: "Power Ranch", lat: 33.2711, lng: -111.7175 },
      { name: "Morrison Ranch", lat: 33.355, lng: -111.735 },
    ],
  },
  {
    slug: "chandler",
    name: "Chandler",
    state: "AZ",
    region: "Maricopa County",
    isPrimary: false,
    lat: 33.3062,
    lng: -111.8413,
    description:
      "Chandler painting services — interior and exterior painting, power washing, pergolas, and sun screens for homes and businesses.",
    highlights: [
      "Residential & commercial painting",
      "Driveway and patio power washing",
      "Custom pergolas & patio covers",
      "Licensed and fully insured",
    ],
    content: [
      "Chandler keeps us busy year-round with interior repaints, exterior color updates, and patio projects. We work in Ocotillo, Sun Lakes, Downtown Chandler, and everywhere between.",
      "Commercial clients here rely on us for office suites, retail storefronts, and rental turnovers scheduled around business hours — including overnight work when a space can't be closed during the day.",
      "Call (480) 758-9380 for free Chandler pricing.",
    ],
    cities: [
      { name: "Ocotillo", lat: 33.245, lng: -111.87 },
      { name: "Sun Lakes", lat: 33.2131, lng: -111.8686 },
      { name: "Downtown Chandler", lat: 33.3062, lng: -111.8413 },
      { name: "Fulton Ranch", lat: 33.2478, lng: -111.855 },
    ],
  },
  {
    slug: "mesa",
    name: "Mesa",
    state: "AZ",
    region: "Maricopa County",
    isPrimary: false,
    lat: 33.4152,
    lng: -111.8315,
    description:
      "Mesa, AZ painters. Interior painting, exterior stucco repaints, power washing, sun screens, and rain gutters across the East Valley.",
    highlights: [
      "Interior & exterior house painting",
      "Stucco crack repair before paint",
      "Power washing driveways & patios",
      "Rain gutter installation & repair",
    ],
    content: [
      "Mesa has everything from 1960s block homes to brand-new builds, and each needs a different approach. Older block and stucco often need crack repair and a proper elastomeric coating; newer homes usually just need a quality two-coat repaint.",
      "We also handle a steady stream of rental and property-management work in Mesa — fast turnarounds between tenants without cutting corners on prep.",
      "Book your free Mesa estimate at (480) 758-9380.",
    ],
    cities: [
      { name: "Downtown Mesa", lat: 33.4152, lng: -111.8315 },
      { name: "Red Mountain", lat: 33.462, lng: -111.72 },
      { name: "Dobson Ranch", lat: 33.375, lng: -111.877 },
      { name: "Las Sendas", lat: 33.475, lng: -111.695 },
    ],
  },
  {
    slug: "apache-junction",
    name: "Apache Junction",
    state: "AZ",
    region: "Pinal County",
    isPrimary: false,
    lat: 33.4151,
    lng: -111.5496,
    description:
      "Apache Junction painting contractor. Exterior repaints built for sun and wind exposure, plus power washing, sun screens, and patio covers.",
    highlights: [
      "Sun- and wind-rated exterior coatings",
      "Interior repaints & drywall repair",
      "Power washing & stain removal",
      "Patio covers and shade structures",
    ],
    content: [
      "Out toward the Superstitions the sun and wind exposure is harsher than in the middle of the Valley, so exterior paint fails faster. We spec heavier coatings and pay extra attention to caulking and south-facing walls.",
      "Apache Junction customers also come to us for pergolas and patio covers — shade is worth more out here than almost anywhere else in the Valley.",
      "Call (480) 758-9380 for a free Apache Junction estimate.",
    ],
    cities: [
      { name: "Gold Canyon", lat: 33.3706, lng: -111.4376 },
      { name: "Superstition Foothills", lat: 33.39, lng: -111.49 },
      { name: "Mountain Brook", lat: 33.36, lng: -111.45 },
    ],
  },
  {
    slug: "san-tan-valley",
    name: "San Tan Valley",
    state: "AZ",
    region: "Pinal County",
    isPrimary: false,
    lat: 33.1926,
    lng: -111.5262,
    description:
      "San Tan Valley house painters. Whole-home interior and exterior repaints, sun screens, seamless gutters, and custom pergolas.",
    highlights: [
      "Whole-home interior repaints",
      "Exterior painting & stucco repair",
      "Sun screens for west-facing windows",
      "Seamless rain gutters",
    ],
    content: [
      "San Tan Valley's subdivisions are hitting the ten-to-fifteen-year mark where builder paint gives out. A proper exterior repaint now — with crack repair and real prep — saves the stucco underneath from far more expensive problems later.",
      "We also install a lot of sun screens and gutters out here, often bundled with an exterior repaint so everything is done in one visit and matched to the same color scheme.",
      "Reach us at (480) 758-9380 for free San Tan Valley pricing.",
    ],
    cities: [
      { name: "Johnson Ranch", lat: 33.19, lng: -111.55 },
      { name: "Circle Cross Ranch", lat: 33.145, lng: -111.545 },
      { name: "Queen Creek", lat: 33.2487, lng: -111.6343 },
    ],
  },
  {
    slug: "florence",
    name: "Florence",
    state: "AZ",
    region: "Pinal County",
    isPrimary: false,
    lat: 33.0314,
    lng: -111.3873,
    description:
      "Florence, AZ painting services. Interior and exterior painting, power washing, and patio structures for Pinal County homes and businesses.",
    highlights: [
      "Interior & exterior painting",
      "Historic and modern home experience",
      "Power washing & surface prep",
      "Free written estimates",
    ],
    content: [
      "Florence mixes historic properties with newer developments, and we work comfortably on both. Older adobe and block need careful prep and breathable coatings; newer stucco takes a standard two-coat exterior system.",
      "We make the drive to Florence regularly, and travel is already built into the estimate — no surprise trip charges on the invoice.",
      "Call (480) 758-9380 for a free Florence estimate.",
    ],
    cities: [
      { name: "Historic Downtown", lat: 33.0314, lng: -111.3873 },
      { name: "Anthem at Merrill Ranch", lat: 33.03, lng: -111.45 },
      { name: "Magma Ranch", lat: 33.0, lng: -111.44 },
    ],
  },
  {
    slug: "casa-grande",
    name: "Casa Grande",
    state: "AZ",
    region: "Pinal County",
    isPrimary: false,
    lat: 32.8795,
    lng: -111.7574,
    description:
      "Casa Grande painting contractor. Residential and commercial painting, power washing, sun screens, and rain gutter installation.",
    highlights: [
      "Residential & commercial painting",
      "Sun screens & energy savings",
      "Rain gutter installation",
      "Licensed and insured crews",
    ],
    content: [
      "Casa Grande homes and businesses get the same crews and the same standards as our Phoenix jobs. Interior repaints, full exterior color changes, storefronts, and warehouse spaces are all regular work for us here.",
      "Because Casa Grande sits in one of the hottest parts of the state, we push customers toward UV-resistant coatings and sun screens — the upfront difference is small and the lifespan difference is not.",
      "Get your free Casa Grande quote at (480) 758-9380.",
    ],
    cities: [
      { name: "Mission Royale", lat: 32.86, lng: -111.79 },
      { name: "Arizona City", lat: 32.7573, lng: -111.6707 },
      { name: "Eloy", lat: 32.7559, lng: -111.5548 },
    ],
  },
  {
    slug: "coolidge",
    name: "Coolidge",
    state: "AZ",
    region: "Pinal County",
    isPrimary: false,
    lat: 32.9779,
    lng: -111.5176,
    description:
      "Coolidge, AZ painters. Honest pricing on interior painting, exterior repaints, power washing, and patio covers.",
    highlights: [
      "Interior & exterior repaints",
      "Driveway & patio power washing",
      "Patio covers and pergolas",
      "Straightforward, written pricing",
    ],
    content: [
      "Coolidge customers get straight answers and written pricing — no vague verbal quotes that change once the work starts. We paint houses, rentals, and small commercial buildings throughout the area.",
      "Power washing is often the first thing we recommend here. A wash alone transforms sun-baked driveways and patios, and it's required prep before any exterior paint goes on.",
      "Call (480) 758-9380 to schedule a free Coolidge estimate.",
    ],
    cities: [
      { name: "Downtown Coolidge", lat: 32.9779, lng: -111.5176 },
      { name: "Randolph", lat: 32.93, lng: -111.55 },
      { name: "Arizona Boulevard", lat: 32.985, lng: -111.525 },
    ],
  },
  {
    slug: "surprise",
    name: "Surprise",
    state: "AZ",
    region: "Maricopa County",
    isPrimary: false,
    lat: 33.6292,
    lng: -112.368,
    description:
      "Surprise, AZ painting services. West Valley interior and exterior painting, sun screens, seamless gutters, and power washing.",
    highlights: [
      "West Valley interior & exterior painting",
      "Sun screens for lower cooling bills",
      "Seamless rain gutters",
      "HOA color approval assistance",
    ],
    content: [
      "Surprise has grown fast and a lot of its neighborhoods are due for their first real repaint. We handle the full exterior system — wash, repair, prime, two coats — plus interiors, gutters, and sun screens.",
      "Most Surprise communities are HOA-governed, so we prepare color samples and submission paperwork as part of the job.",
      "Call (480) 758-9380 for your free Surprise estimate.",
    ],
    cities: [
      { name: "Marley Park", lat: 33.63, lng: -112.375 },
      { name: "Sun City Grand", lat: 33.65, lng: -112.4 },
      { name: "Litchfield Park", lat: 33.4934, lng: -112.3579 },
    ],
  },
  {
    slug: "sun-city",
    name: "Sun City",
    state: "AZ",
    region: "Maricopa County",
    isPrimary: false,
    lat: 33.5975,
    lng: -112.2718,
    description:
      "Sun City painting contractor. Patient, tidy crews for interior repaints, exterior painting, sun screens, and gutter work.",
    highlights: [
      "Respectful, tidy crews",
      "Interior repaints & trim work",
      "Exterior painting & stucco repair",
      "10% discount for military & veterans",
    ],
    content: [
      "Sun City residents tell us the same thing every time: they want a crew that shows up when promised, keeps the house clean, and explains what's happening. That's exactly how we run every job.",
      "We do a lot of interior repaints, trim and door refreshes, sun screen installs, and gutter repairs here — and our 10% military and veteran discount applies to all of it.",
      "Call (480) 758-9380 for a free Sun City estimate.",
    ],
    cities: [
      { name: "Sun City West", lat: 33.6614, lng: -112.3513 },
      { name: "Youngtown", lat: 33.5906, lng: -112.3025 },
      { name: "El Mirage", lat: 33.6131, lng: -112.3246 },
    ],
  },
  {
    slug: "goodyear",
    name: "Goodyear",
    state: "AZ",
    region: "Maricopa County",
    isPrimary: false,
    lat: 33.4353,
    lng: -112.3576,
    description:
      "Goodyear, AZ house painters. Exterior repaints, interior painting, pergolas, and power washing across the West Valley.",
    highlights: [
      "Exterior repaints & stucco repair",
      "Interior painting & cabinet finishes",
      "Custom pergolas & patio covers",
      "Free written estimates",
    ],
    content: [
      "Goodyear's newer neighborhoods take full afternoon sun with very little mature shade, which is hard on both paint and patios. We use UV-resistant exterior systems and build a lot of pergolas out here for exactly that reason.",
      "Interior work in Goodyear runs the full range — single accent walls, whole-home repaints, and cabinet refinishing that saves the cost of a full kitchen replacement.",
      "Get free Goodyear pricing at (480) 758-9380.",
    ],
    cities: [
      { name: "Estrella", lat: 33.315, lng: -112.36 },
      { name: "Palm Valley", lat: 33.475, lng: -112.37 },
      { name: "Verrado", lat: 33.4785, lng: -112.4463 },
    ],
  },
  {
    slug: "avondale",
    name: "Avondale",
    state: "AZ",
    region: "Maricopa County",
    isPrimary: false,
    lat: 33.4356,
    lng: -112.3496,
    description:
      "Avondale painting services. Interior and exterior painting, power washing, sun screens, and rain gutters for West Valley homes.",
    highlights: [
      "Interior & exterior house painting",
      "Power washing driveways & walls",
      "Sun screens & rain gutters",
      "Bilingual service in English & Spanish",
    ],
    content: [
      "Avondale families get friendly, bilingual service in English and Spanish from the first phone call to the final walkthrough. We paint houses, apartments, and small businesses throughout the city.",
      "Bundling works well in Avondale: an exterior repaint plus power washing, sun screens, and gutters in one visit costs less than booking each separately.",
      "Call (480) 758-9380 for your free Avondale estimate.",
    ],
    cities: [
      { name: "Old Town Avondale", lat: 33.4356, lng: -112.3496 },
      { name: "Garden Lakes", lat: 33.465, lng: -112.33 },
      { name: "Tolleson", lat: 33.4501, lng: -112.2593 },
    ],
  },
  {
    slug: "peoria",
    name: "Peoria",
    state: "AZ",
    region: "Maricopa County",
    isPrimary: false,
    lat: 33.5806,
    lng: -112.2374,
    description:
      "Peoria, AZ painting contractor. Interior repaints, exterior stucco painting, pergolas, sun screens, and seamless gutters.",
    highlights: [
      "Interior repaints & trim work",
      "Exterior stucco & block painting",
      "Pergolas and shade structures",
      "Open 24/7 for scheduling",
    ],
    content: [
      "From Old Town Peoria up through Vistancia, we repaint interiors and exteriors, build patio structures, and install sun screens and gutters. Same crews, same standards, whichever side of the Valley you're on.",
      "Our phones are on 24/7, so you can book a Peoria estimate at whatever hour actually works for your schedule.",
      "Call (480) 758-9380 for free Peoria pricing.",
    ],
    cities: [
      { name: "Old Town Peoria", lat: 33.5806, lng: -112.2374 },
      { name: "Vistancia", lat: 33.735, lng: -112.32 },
      { name: "Fletcher Heights", lat: 33.63, lng: -112.24 },
    ],
  },
];

export const primaryLocation = locations.find((l) => l.isPrimary) ?? locations[0];
